// front/src/components/layout/Navbar/Navbar.styles.js
import styled from 'styled-components';

export const NavbarContainer = styled.div`
  z-index: 20;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1px 20px;
  height: 55px; 
  background: linear-gradient(90deg, #61b3a6, #1e4959);
  color: white;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    padding: 0px 15px;
    height: 50px; 
  }
`;

export const Logo = styled.div`
  font-size: 1.6rem;
  font-weight: bold;
  
  @media (max-width: 768px) {
    font-size: 1.4rem; 
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  position: relative;

  @media (max-width: 768px) {
    gap: 15px;
  }
`;

export const Icon = styled.div`
  font-size: 1rem;
  cursor: pointer;
  color: white;
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }

  .material-symbols-outlined {
    font-size: 24px;
  }
`;

export const LogoutButton = styled.button`
  background-color: #f7921e;
  border: none;
  border-radius: 8px;
  color: white;
  padding: 5px 15px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #e08119;
  }

  @media (max-width: 768px) {
    padding: 5px 10px; 
    font-size: 0.9rem; 
  }
`;

export const NotificationDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #f0e6dd;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(255, 159, 31, 0.4);
  width: 440px;
  max-width: 90vw;
  max-height: 70vh;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 10px;
  padding: 6px 0;
`;

export const UserDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  margin-top: 8px;
`;

export const DropdownItem = styled.div`
  padding: 12px 16px;
  color: #2c3e50;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f8f9fa;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f8f9fa;
  }
`;

export const NotificationBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #f50537;
  color: white;
  font-size: 10px;
  font-weight: bold;
  line-height: 16px;
  text-align: center;
`;

export const NotificationItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 18px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #eef1f3;
  background: ${({ $lida }) => ($lida ? 'white' : '#f5faf9')};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f1f5f4;
  }
`;

export const NotificationGrip = styled.span`
  color: #b8c2c7;
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
`;

export const NotificationConteudo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const NotificationLinhaTopo = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
`;

export const NotificationTitulo = styled.div`
  color: #1e4959;
  font-weight: 700;
  font-size: 0.98rem;
  line-height: 1.25;
  white-space: nowrap;
`;

export const NotificationData = styled.span`
  color: #1e4959;
  font-size: 0.72rem;
  font-weight: 700;
  font-style: italic;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const NotificationMensagem = styled.div`
  color: #4a5b63;
  font-size: 0.85rem;
  margin-top: 3px;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const NotificationEmpty = styled.div`
  padding: 16px;
  color: #7a8a91;
  font-size: 0.85rem;
  text-align: center;
`;

export const NotificationErro = styled.div`
  padding: 12px 16px;
  color: #c0392b;
  background: #fdecea;
  border-bottom: 1px solid #f5c6c2;
  font-size: 0.82rem;
  text-align: center;
`;

export const NotificationFooter = styled.div`
  padding: 8px 16px;
  border-top: 1px solid #e1e5e9;
  text-align: center;
`;

export const MarcarTodasButton = styled.button`
  background: none;
  border: none;
  color: #1e4959;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;